'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fetchRuleExecutor = fetchRuleExecutor;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _effects = require('redux-saga/effects');

var _redux = require('@adparlor-devops/js-anvil/redux');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchRuleExecutor].map(_regenerator2.default.mark);

function fetchRuleExecutor(_ref) {
  var payload = _ref.payload;
  var ENDPOINTS, request;
  return _regenerator2.default.wrap(function fetchRuleExecutor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session.ENDPOINTS;
          });

        case 2:
          ENDPOINTS = _context.sent;
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.ripple_api_url + '/rules/' + payload.ruleId);

        case 6:
          request = _context.sent;
          _context.next = 9;
          return (0, _effects.put)({ type: _constants.FETCH_RULE_SUCCESS, payload: request.data });

        case 9:
          _context.next = 17;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](3);
          _context.next = 15;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context.t0 });

        case 15:
          _context.next = 17;
          return (0, _effects.put)({ type: _constants.FETCH_RULE_ERROR, payload: { id: payload.ruleId } });

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[3, 11]]);
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/rules/sagas/executors.js
// module id = 3441
// module chunks = 2